import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "primeicons/primeicons.css";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/theme.css";
import "./assets/styles.scss";
import "./styles/app.scss";
import "./styles/view-styles.scss";
import App from "./App";
import { AppProvider } from "./context/AppContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppProvider>
    <App />
  </AppProvider>
);
